import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/Sonner';
import { FleetProvider } from './contexts/FleetContext';
import { AppLayout } from './components/layout/AppLayout';
import { Dashboard } from './pages/Dashboard';
import { Orders } from './pages/Orders';
import { Drivers } from './pages/Drivers';
import { Analytics } from './pages/Analytics';
import { SettingsPage } from './pages/Settings';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mm2nskb9r362">
      <FleetProvider data-id="element-1" data-mp="2mmlv773am95u">
        <Routes data-id="element-2" data-mp="2mndqegsza4vl">
          <Route element={<AppLayout data-id="element-4" data-mp="2mjzn96chprn3" />} data-id="element-3" data-mp="2mjpuxc3z38e8">
            <Route index element={<Dashboard data-id="element-6" data-mp="31bs09botatln" />} data-id="element-5" data-mp="31b8l22qjqjbb" />
            <Route path="/orders" element={<Orders data-id="element-8" data-mp="2wk0av4he6tx3" />} data-id="element-7" data-mp="31c1igd3m7wgs" />
            <Route path="/drivers" element={<Drivers data-id="element-10" data-mp="2wifh3h2wjf0a" />} data-id="element-9" data-mp="2wjqgl4pbe0ll" />
            <Route path="/analytics" element={<Analytics data-id="element-12" data-mp="28tw9l3rof699" />} data-id="element-11" data-mp="2wi5lndz38fn7" />
            <Route path="/settings" element={<SettingsPage data-id="element-14" data-mp="28s2y9b64bxux" />} data-id="element-13" data-mp="28t4j27cxrypu" />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors closeButton data-id="element-15" data-mp="23ujl6el5pr4k" />
      </FleetProvider>
    </BrowserRouter>;
}